<template>
  <div class="copyright-area bg-white text-center py-4">
    <div class="container">
      <p class="fs-14">
        <span class="text-primary-div"></span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CopyRight",
});
</script>
